import React from 'react'

export const SicknessPeriodAdmin = () => {
  return (
   <>
        <section class="m-0 content" dir='rtl'>
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">سیر بیماری روزانه کاربر</div>
                        <p class="card-subtitle">جهت تکمیل روند سیر بیماری خود فرم زیر را تکمیل نمایید</p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-24">
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" readOnly  placeholder="شماره پرونده"/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام و نام خانوادگی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پدر" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="روز" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="ماه" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="سال" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2 border-danger" placeholder="نام بخش" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره اتاق"/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تخت" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="پزشک معالج" />
                        </div>
                    </div>
                    <div class="seprator my-24"></div>
                    <div class="d-flex flex-column w-100" id="parent_sickness">
                        <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                            <div class="custom-form-control form-group position-relative w-50">
                                <input type="text" class="form-control pr-16 my-2" placeholder="معالج انجام شده" />
                            </div>
                            <div class="custom-form-control form-group position-relative w-50 m-0 ms-md-3">
                                <input type="text" class="form-control pr-16 my-2" placeholder="نتیجه نهایی"  />
                            </div>
                        </div>
                    </div>
                    <button class="custom-btn-primary t-24 form-submit p-16">
                        ثبت 
                    </button>
                </div>
            </div>
        </section>
   </>
  )
}
